import { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tbolt_token');
    const saved = localStorage.getItem('tbolt_user');
    if (token && saved) {
      setUser(JSON.parse(saved));
      getMe()
        .then(res => {
          setUser(res.data);
          localStorage.setItem('tbolt_user', JSON.stringify(res.data));
        })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  function loginUser(token, userData) {
    localStorage.setItem('tbolt_token', token);
    localStorage.setItem('tbolt_user', JSON.stringify(userData));
    setUser(userData);
  }

  function logout() {
    localStorage.removeItem('tbolt_token');
    localStorage.removeItem('tbolt_user');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}